module.exports = __webpack_public_path__ + "img/img_icon_12.5493d9f9.png";